import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class OperationMessageService {

  constructor(private translate: TranslateService,) { }

  GetSuccessMessage(){
    const successMessage = this.translate.instant('messages.success');
    return successMessage;
  }
  GetErrorMessage(){
     return this.translate.instant('messages.error')
  }
}
